var _path, _path2, _g, _path3, _path4, _g2, _path5, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 128,
    viewBox: "0 0 125 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group 2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 652",
    d: "M62.5 124.5C96.7417 124.5 124.5 96.7417 124.5 62.5C124.5 28.2583 96.7417 0.5 62.5 0.5C28.2583 0.5 0.5 28.2583 0.5 62.5C0.5 96.7417 28.2583 124.5 62.5 124.5Z",
    fill: "#EAECF0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_1810_6065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1810_6065",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 125,
    height: 125
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 653",
    d: "M62.5 124.5C96.7417 124.5 124.5 96.7417 124.5 62.5C124.5 28.2583 96.7417 0.5 62.5 0.5C28.2583 0.5 0.5 28.2583 0.5 62.5C0.5 96.7417 28.2583 124.5 62.5 124.5Z",
    fill: "#FE4444"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1810_6065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5615",
    d: "M98.047 36.0469H26.9536C24.6709 36.0469 22.8203 37.8974 22.8203 40.1802V126.98C22.8203 129.263 24.6709 131.114 26.9536 131.114H98.047C100.33 131.114 102.18 129.263 102.18 126.98V40.1802C102.18 37.8974 100.33 36.0469 98.047 36.0469Z",
    fill: "white"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5617",
    d: "M55.0593 44.3135H33.5659C32.1963 44.3135 31.0859 45.4238 31.0859 46.7935C31.0859 48.1631 32.1963 49.2735 33.5659 49.2735H55.0593C56.4289 49.2735 57.5393 48.1631 57.5393 46.7935C57.5393 45.4238 56.4289 44.3135 55.0593 44.3135Z",
    fill: "#EAECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5620",
    d: "M55.0593 79.0332H33.5659C32.1963 79.0332 31.0859 80.1435 31.0859 81.5132C31.0859 82.8829 32.1963 83.9932 33.5659 83.9932H55.0593C56.4289 83.9932 57.5393 82.8829 57.5393 81.5132C57.5393 80.1435 56.4289 79.0332 55.0593 79.0332Z",
    fill: "#EAECF0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 5618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M89.7768 56.7129H35.2168C33.3906 56.7129 31.9102 58.1933 31.9102 60.0196V68.2862C31.9102 70.1124 33.3906 71.5929 35.2168 71.5929H89.7768C91.6031 71.5929 93.0835 70.1124 93.0835 68.2862V60.0196C93.0835 58.1933 91.6031 56.7129 89.7768 56.7129Z",
    stroke: "#FE4444",
    strokeWidth: 2
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5619",
    d: "M89.7793 90.6069H35.2193C32.9365 90.6069 31.0859 92.4575 31.0859 94.7403V101.354C31.0859 103.636 32.9365 105.487 35.2193 105.487H89.7793C92.062 105.487 93.9126 103.636 93.9126 101.354V94.7403C93.9126 92.4575 92.062 90.6069 89.7793 90.6069Z",
    fill: "#EAECF0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 26781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 654",
    d: "M44.3145 26.9532C46.1407 26.9532 47.6211 25.4727 47.6211 23.6465C47.6211 21.8203 46.1407 20.3398 44.3145 20.3398C42.4883 20.3398 41.0078 21.8203 41.0078 23.6465C41.0078 25.4727 42.4883 26.9532 44.3145 26.9532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 655",
    d: "M62.502 26.9532C64.3282 26.9532 65.8086 25.4727 65.8086 23.6465C65.8086 21.8203 64.3282 20.3398 62.502 20.3398C60.6758 20.3398 59.1953 21.8203 59.1953 23.6465C59.1953 25.4727 60.6758 26.9532 62.502 26.9532Z",
    fill: "#FE4444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 656",
    d: "M80.6895 26.9532C82.5157 26.9532 83.9961 25.4727 83.9961 23.6465C83.9961 21.8203 82.5157 20.3398 80.6895 20.3398C78.8633 20.3398 77.3828 21.8203 77.3828 23.6465C77.3828 25.4727 78.8633 26.9532 80.6895 26.9532Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 26782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 658",
    d: "M71.5943 73.2471C73.877 73.2471 75.7276 71.3966 75.7276 69.1138C75.7276 66.831 73.877 64.9805 71.5943 64.9805C69.3115 64.9805 67.4609 66.831 67.4609 69.1138C67.4609 71.3966 69.3115 73.2471 71.5943 73.2471Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 25916",
    d: "M74.8244 86.7801C74.1631 86.7801 73.5456 86.7801 72.9835 86.7445C72.291 86.6977 71.6249 86.4608 71.0585 86.0598C70.492 85.6589 70.0471 85.1095 69.7727 84.472L66.285 77.5793C66.0292 77.2814 65.9014 76.8946 65.9296 76.503C65.9578 76.1114 66.1396 75.7468 66.4354 75.4886C66.6778 75.2939 66.9801 75.189 67.291 75.1919C67.5199 75.1985 67.7447 75.2547 67.9497 75.3566C68.1548 75.4585 68.3354 75.6037 68.4789 75.7821L70.0628 77.9438L70.0868 77.9719V69.759C70.0868 69.3516 70.2487 68.9608 70.5368 68.6726C70.8249 68.3845 71.2157 68.2227 71.6232 68.2227C72.0306 68.2227 72.4214 68.3845 72.7095 68.6726C72.9977 68.9608 73.1595 69.3516 73.1595 69.759V75.1324C73.1417 74.9346 73.1652 74.7353 73.2287 74.5472C73.2921 74.3591 73.394 74.1862 73.5279 74.0397C73.6619 73.8931 73.8248 73.7761 74.0065 73.696C74.1882 73.6159 74.3845 73.5746 74.5831 73.5746C74.7816 73.5746 74.9779 73.6159 75.1596 73.696C75.3413 73.7761 75.5043 73.8931 75.6382 74.0397C75.7721 74.1862 75.874 74.3591 75.9374 74.5472C76.0009 74.7353 76.0244 74.9346 76.0066 75.1324V76.2525C75.9887 76.0548 76.0123 75.8555 76.0757 75.6674C76.1391 75.4792 76.241 75.3064 76.375 75.1598C76.5089 75.0133 76.6719 74.8962 76.8535 74.8161C77.0352 74.7361 77.2316 74.6947 77.4301 74.6947C77.6286 74.6947 77.825 74.7361 78.0066 74.8161C78.1883 74.8962 78.3513 75.0133 78.4852 75.1598C78.6191 75.3064 78.7211 75.4792 78.7845 75.6674C78.8479 75.8555 78.8715 76.0548 78.8536 76.2525V77.1155C78.8358 76.9178 78.8593 76.7185 78.9227 76.5304C78.9862 76.3423 79.0881 76.1694 79.222 76.0229C79.3559 75.8763 79.5189 75.7593 79.7006 75.6792C79.8822 75.5991 80.0786 75.5577 80.2771 75.5577C80.4757 75.5577 80.672 75.5991 80.8537 75.6792C81.0353 75.7593 81.1983 75.8763 81.3322 76.0229C81.4662 76.1694 81.5681 76.3423 81.6315 76.5304C81.695 76.7185 81.7185 76.9178 81.7007 77.1155V82.3541C81.6725 83.9653 80.9443 86.6817 78.3824 86.6817C78.1964 86.69 76.6208 86.7809 74.8277 86.7809L74.8244 86.7801Z",
    fill: "#FE4444",
    stroke: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1810_6065",
    x: 16.8203,
    y: 27.0469,
    width: 91.3594,
    height: 100.453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1810_6065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1810_6065",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.c146b0ac34f0c62694d55553009375f4.svg";
export { ForwardRef as ReactComponent };